module.exports = __webpack_public_path__ + "static/img/SCW部件组成1-高清显示屏.f3b7d46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-3/SCW部件组成1-高清显示屏.png
// module id = RmH+
// module chunks = 0